import { render, staticRenderFns } from "./Apresentation.vue?vue&type=template&id=2ad64ecf&"
import script from "./Apresentation.vue?vue&type=script&lang=js&"
export * from "./Apresentation.vue?vue&type=script&lang=js&"
import style0 from "./Apresentation.vue?vue&type=style&index=0&id=2ad64ecf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports